module.exports = __webpack_public_path__ + "images/12-08_418298e2.jpg";